
export default {
  props: ["school_infra"],
  data() {
    return {
      overflow: {
        facility: {
          isOverflow: false,
          isExpanded: false,
        },
      },
    };
  },
  methods: {
    handleExpanding(name) {
      this.overflow[name].isExpanded = !this.overflow[name].isExpanded;
    },
  },
  watch: {
    "overflow.facility.isExpanded"(value) {
      value
        ? (this.$refs.facilityRef.style.height = "100%")
        : (this.$refs.facilityRef.style.height = "360px");
    },
  },
  mounted(){
    const facilityRef = this.$refs.facilityRef;
    // console.log({height:facilityRef.clientHeight})
    const limitedHeight = 360;
    if (facilityRef.clientHeight > limitedHeight) {
      this.overflow.facility.isOverflow = true;
      facilityRef.style.height = `${limitedHeight}px`;
    }
  
  
  }
};
